import * as endpoints from './endpoints'

export type Image = {
  bytes: ArrayBuffer
  type: string
  src?: string
}

export function fromBlob(file: Blob): Promise<Image> {
  return new Promise<Image>(resolve => {
    const fileReader = new FileReader()
    fileReader.readAsArrayBuffer(file)
    fileReader.onload = () => {
      const bytes = fileReader.result as ArrayBuffer
      const type = file.type
      resolve({ bytes, type })
    }
  })
}

export async function upload(raw: Image): Promise<Image> {
  const accessToken = localStorage.getItem('access-token')
  if (!accessToken) return raw
  const regex = /projects\/(.*)\/proposals\/(.*)/
  const match = location.pathname.match(regex)
  if (!match) return raw
  const { bytes, type } = raw
  const at = `projects/${match[1]}/proposals/${match[2]}/uploads`
  const endpoint = `${endpoints.heimdall()}/${at}`
  const authorization = `Bearer ${accessToken}`
  const headers = { 'content-type': type, authorization }
  const res = await fetch(endpoint, { method: 'POST', headers, body: bytes })
  if (!res.ok) return raw
  const { name } = await res.json()
  const src = imageSrc(match[1], match[2], name)
  return { src, bytes, type }
}

function imageSrc(projectID: string, proposalID: string, name: string): string {
  const upload = `projects/${projectID}/proposals/${proposalID}/uploads`
  return [endpoints.heimdall(), upload, name].join('/')
}
